import { memo, useId, type SVGProps } from "react";

import { withUniqueSvgIds } from "./withUniqueSvgIds";

const SvgWhatsApp = (props: SVGProps<SVGSVGElement>) => {
  const idPrefix = useId().replace(/:/g, "");

  return withUniqueSvgIds(
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 561 561"
      aria-hidden="true"
      {...props}
    >
      <path
        fill="currentColor"
        d="M407.2 336.3c-7-3.5-41.1-20.3-47.5-22.6s-11-3.5-15.6 3.5c-4.7 7-18 22.6-22 27.2s-8.1 5.2-15 1.7c-7-3.4-29.4-10.8-56-34.4a209.4 209.4 0 0 1-38.6-48.2c-4-7-.4-10.7 3-14.2 3.2-3 7-8 10.5-12.1 3.4-4 4.6-7 7-11.6 2.2-4.7 1-8.7-.7-12.2s-15.6-37.7-21.4-51.6c-5.6-13.5-11.4-11.7-15.6-12l-13.3-.2c-4.7 0-12.2 1.8-18.6 8.7-6.3 7-24.3 23.8-24.3 58s25 67.2 28.4 71.9c3.5 4.6 49 74.8 118.7 104.9a399 399 0 0 0 39.6 14.6 95.2 95.2 0 0 0 43.8 2.8c13.3-2 41-16.8 46.8-33 5.8-16.3 5.8-30.2 4.1-33.1s-6.4-4.6-13.3-8.1m-126.8 173c-41.6 0-82.2-11-117.7-32.1l-8.5-5L66.8 495 90 409.8l-5.5-8.7A231.5 231.5 0 0 1 280.5 47c61.7 0 119.8 24 163.4 67.7a231.5 231.5 0 0 1-163.5 394.6M477.1 81.6A276.3 276.3 0 0 0 280.4 0a278.5 278.5 0 0 0-241 417L0 561.3l147.4-38.7a277.8 277.8 0 0 0 132.9 33.8h.1c153.3 0 278-124.7 278-278 .1-74.3-28.8-144.2-81.3-196.7"
      />
    </svg>,
    idPrefix,
  );
};

const Memo = memo(SvgWhatsApp);
export default Memo;
